import { render } from "./FollowupActions.vue?vue&type=template&id=98b42592&scoped=true"
import script from "./FollowupActions.vue?vue&type=script&lang=js"
export * from "./FollowupActions.vue?vue&type=script&lang=js"

import "./FollowupActions.vue?vue&type=style&index=0&id=98b42592&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98b42592"]])

export default __exports__